import find from 'lodash/find';
import min from 'lodash/min';
import max from 'lodash/max';
import sum from 'lodash/sum';
import sumBy from 'lodash/sumBy';
import map from 'lodash/map';
import merge from 'lodash/merge';
import uniq from 'lodash/uniq';
import filter from 'lodash/filter';
import first from 'lodash/first';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import deepMerge from 'lodash/merge';
import flatten from 'lodash/flatten';
import includes from 'lodash/includes';
import capitalize from 'lodash/capitalize';
import set from 'lodash/set';

export {
  capitalize, min, max, deepMerge, find, sum, map, merge, filter, first, includes, isEqual, isEmpty, flatten, sumBy, uniq, set,
};
